import styled from '@emotion/styled';
import React from 'react';
import { COLOR } from '@ordermentum/ui-constants';
import FormErrors from '../../atoms/FormErrors';

const ErrorsContainer = styled('div')`
  width: 100%;
  > * {
    font-size: 12px !important;
  }
  .error-text {
    color: ${COLOR.RED_ERROR};
    font-size: 12px !important;
  }
`;

export const errorComponent = (errors: {}, status?: { msg?: string }) =>
  (Object.entries(errors).length > 0 && (
    <ErrorsContainer>
      {' '}
      <FormErrors noIcon errors={errors} />
    </ErrorsContainer>
  )) ||
  (status && status.msg && (
    <ErrorsContainer>
      {' '}
      <FormErrors noIcon errors={status} />
    </ErrorsContainer>
  ));
